/**
 * Restrictions Service
 * Handles all API calls related to property restrictions data
 */

import { apiRequest } from './api';
import config from '../config';

/**
 * Fetch planning restrictions for a specific location
 *
 * @param {string} postcode - Property postcode
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @returns {Promise<Object>} - Planning restrictions data
 */
const getRestrictions = async (postcode, lat, lng) => {
  if (!postcode || !lat || !lng) {
    console.error('Missing required parameters for restrictions search:', { postcode, lat, lng });
    throw new Error('Missing required location parameters');
  }

  // Create cache key based on location
  const cacheKey = `restrictions_${postcode}_${lat}_${lng}`;

  // Build URL with query parameters
  const url = `${config.apiUrl}/restrictions/search?postcode=${encodeURIComponent(
    postcode,
  )}&lat=${lat}&lng=${lng}`;

  try {
    return await apiRequest(url, {}, cacheKey);
  } catch (error) {
    console.error('Error fetching restrictions data:', error);
    throw error;
  }
};

export { getRestrictions };
